import { z } from "zod";
import { ColumnSchema, ViewSchema, ViewType } from "./views";

export enum GeneralLedgerColumn {
    NAME = "name",
    SOURCE = "source",
    REFERENCE = "reference",
    DESCRIPTION = "description",
    MEMO = "memo",
    ENTITY = "entity",
    COUNTERPARTY = "counterparty",
    CLASS = "class",
    SPLIT = "split",
    EXCLUDE_FROM_1099 = "excludeFrom1099",
    AMOUNT = "amount",
    BALANCE = "balance",
}

const NameColumnSchema = ColumnSchema.extend({
    id: z.literal(GeneralLedgerColumn.NAME),
});
export type NameColumn = z.infer<typeof NameColumnSchema>;

const SourceColumnSchema = ColumnSchema.extend({
    id: z.literal(GeneralLedgerColumn.SOURCE),
});
export type SourceColumn = z.infer<typeof SourceColumnSchema>;

const ReferenceColumnSchema = ColumnSchema.extend({
    id: z.literal(GeneralLedgerColumn.REFERENCE),
});
export type ReferenceColumn = z.infer<typeof ReferenceColumnSchema>;

const DescriptionColumnSchema = ColumnSchema.extend({
    id: z.literal(GeneralLedgerColumn.DESCRIPTION),
});
export type DescriptionColumn = z.infer<typeof DescriptionColumnSchema>;

const MemoColumnSchema = ColumnSchema.extend({
    id: z.literal(GeneralLedgerColumn.MEMO),
});
export type MemoColumn = z.infer<typeof MemoColumnSchema>;

const EntityColumnSchema = ColumnSchema.extend({
    id: z.literal(GeneralLedgerColumn.ENTITY),
});
export type EntityColumn = z.infer<typeof EntityColumnSchema>;

const CounterpartyColumnSchema = ColumnSchema.extend({
    id: z.literal(GeneralLedgerColumn.COUNTERPARTY),
});
export type CounterpartyColumn = z.infer<typeof CounterpartyColumnSchema>;

const ClassColumnSchema = ColumnSchema.extend({
    id: z.literal(GeneralLedgerColumn.CLASS),
});
export type ClassColumn = z.infer<typeof ClassColumnSchema>;

const SplitColumnSchema = ColumnSchema.extend({
    id: z.literal(GeneralLedgerColumn.SPLIT),
});
export type SplitColumn = z.infer<typeof SplitColumnSchema>;

const ExcludeFrom1099ColumnSchema = ColumnSchema.extend({
    id: z.literal(GeneralLedgerColumn.EXCLUDE_FROM_1099),
});
export type ExcludeFrom1099Column = z.infer<typeof ExcludeFrom1099ColumnSchema>;

const AmountColumnSchema = ColumnSchema.extend({
    id: z.literal(GeneralLedgerColumn.AMOUNT),
});
export type AmountColumn = z.infer<typeof AmountColumnSchema>;

const BalanceColumnSchema = ColumnSchema.extend({
    id: z.literal(GeneralLedgerColumn.BALANCE),
});
export type BalanceColumn = z.infer<typeof BalanceColumnSchema>;

export const GeneralLedgerViewSchema = ViewSchema.extend({
    type: z.literal(ViewType.GENERAL_LEDGER),
    columns: z.array(
        z.discriminatedUnion("id", [
            NameColumnSchema,
            SourceColumnSchema,
            ReferenceColumnSchema,
            DescriptionColumnSchema,
            MemoColumnSchema,
            EntityColumnSchema,
            CounterpartyColumnSchema,
            ClassColumnSchema,
            SplitColumnSchema,
            ExcludeFrom1099ColumnSchema,
            AmountColumnSchema,
            BalanceColumnSchema,
        ]),
    ),
});

export type GeneralLedgerView = z.infer<typeof GeneralLedgerViewSchema>;
